/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Diet_TargetInputs */

const en_for_whom_diet_target = /** @type {(inputs: For_Whom_Diet_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily target`)
};

const pl_for_whom_diet_target = /** @type {(inputs: For_Whom_Diet_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel na dzień`)
};

/**
* | output |
* | --- |
* | "Daily target" |
*
* @param {For_Whom_Diet_TargetInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_diet_target = /** @type {((inputs?: For_Whom_Diet_TargetInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Diet_TargetInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_diet_target(inputs)
	return en_for_whom_diet_target(inputs)
});